module.exports = __webpack_public_path__ + "static/img/CARRARA-PORTLAND-CHERRY.c8515c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/CARRARA-PORTLAND-CHERRY.png
// module id = TpV+
// module chunks = 0